module.exports = __webpack_public_path__ + "img/jifen.ddae5fe8.png";